import { Component, EventEmitter, Input, Output } from '@angular/core';
import { InvoiceDetail } from '@viewbid/ts-angular-client';
import { VbChipTone } from '@viewbid/ui';

/**
 * Order summary rail (handoff §6): "Your items" + status chip, item rows,
 * totals breakdown, and the desktop Confirm button (the mobile sticky bar in
 * the page shell stands in below the stacking breakpoint). All mode logic —
 * chip label/tone, confirm label/enablement, shipping-TBD — is computed by
 * the parent page and passed in.
 */
@Component({
    selector: 'vb-invoice-summary',
    templateUrl: './invoice-summary.component.html',
    styleUrls: ['./invoice-summary.component.scss'],
})
export class InvoiceSummaryComponent {
    @Input() invoiceDetails: InvoiceDetail | null = null;
    @Input() paymentSuccess: boolean = false;
    @Input() isLoading: boolean = false;
    @Input() chipLabel: string = '';
    @Input() chipTone: VbChipTone = 'neutral';
    @Input() confirmEnabled: boolean = false;
    @Input() confirmLabel: string = 'Confirm payment';
    /** Shipping fulfillment confirmed — show the "Shipping · TBD" row. */
    @Input() showShippingTbd: boolean = false;
    @Output() confirm: EventEmitter<void> = new EventEmitter<void>();

    get amountPaid(): number {
        return this.invoiceDetails?.invoice?.amountPaid ?? 0;
    }

    get amountDue(): number {
        return this.invoiceDetails?.invoice?.amountDue ?? 0;
    }

    confirmPayment(): void {
        this.confirm.emit();
    }
}
